import { Link } from "react-router-dom";

export default function CTASection() {
  return (
    <section className="relative py-20 md:py-28 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20golden%20hour%20fashion%20lifestyle%20scene%20with%20soft%20cream%20textiles%20and%20subtle%20sage%20green%20accents%2C%20elegant%20product%20styling%20on%20light%20wooden%20surface%2C%20dreamy%20bokeh%20background%20with%20gentle%20natural%20light%20flares%2C%20sophisticated%20modern%20editorial%20aesthetic%2C%20Western%20contemporary%20luxury%20atmosphere%2C%20calming%20and%20aspirational%20mood%2C%20refined%20commercial%20photography%20with%20artistic%20sensibility%2C%20premium%20brand%20campaign%20quality%2C%20soft%20focus%20edges%20creating%20depth%2C%20inviting%20warm%20composition&width=1600&height=700&seq=cta-bg-vb-v2-2026z&orientation=landscape"
          alt="Start exploring Vigorbuy Spreadsheet today"
          title="Explore Vigorbuy Spreadsheet - Get Started"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/45 to-black/60"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full px-4 md:px-6 lg:px-8">
        <div className="max-w-2xl mx-auto text-center">
          <h2 className="text-2xl md:text-4xl lg:text-5xl font-heading font-bold text-white leading-tight mb-5">
            Start Exploring Vigorbuy{" "}
            <span className="text-accent-400">Spreadsheet</span> Today
          </h2>
          <p className="text-sm md:text-base text-white/70 max-w-xl mx-auto mb-8 leading-relaxed">
            Join thousands of smart shoppers who use Vigorbuy Spreadsheet for
            organized product discovery. Browse 14 fashion categories, read
            detailed guides, and make informed decisions — all in one place.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="group inline-flex items-center gap-2 px-8 py-4 bg-primary-500 text-background-50 text-sm md:text-base font-semibold rounded-full hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer shadow-lg shadow-primary-500/30"
            >
              <div className="w-7 h-7 rounded-full bg-accent-500 flex items-center justify-center">
                <i className="ri-shopping-bag-line text-xs text-background-50"></i>
              </div>
              Explore Vigorbuy Spreadsheet
              <i className="ri-arrow-right-up-line text-sm group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform duration-200"></i>
            </a>
            <Link
              to="/vigorbuy-spreadsheet-guide"
              className="inline-flex items-center gap-2 px-8 py-4 bg-white/15 backdrop-blur-sm text-white text-sm md:text-base font-semibold rounded-full border border-white/25 hover:bg-white/25 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              Read Complete Guide
              <i className="ri-book-open-line text-sm"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}